import { darkThemeStyles } from '@jupiterone/jupiter-web-toolkit';
import { TableCell, TableHead, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';

const useStyles = makeStyles(darkThemeStyles);

const ApiKeysTableHeader = () => {
  const classes = useStyles();

  const headerCells: string[] = ['NAME', 'API KEY', 'CREATED', 'EXPIRES', ''];

  return (
    <TableHead>
      <TableRow classes={{ root: classes.rootRow, head: classes.headRow }}>
        {headerCells.map((headerCell: string) => (
          <TableCell
            key={headerCell}
            classes={{ root: classes.rootCell, head: classes.headCell }}
          >
            {headerCell}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default ApiKeysTableHeader;
